import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { PagedResponse, RGPDLabs, RGPDPreferences } from '../models/rgpdLabs';


@Injectable({ providedIn: 'root' })
export class RgpdService extends BaseService {
    route = new ApiConfiguration();

    constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
    }

    ApiComunicadosGetPath = this.config.rootUrl + '/api/rgpd';

    // GET main labs
    getMainRgpdLabs(): Observable<RGPDLabs[]> {
        return this.http.get<RGPDLabs[]>(this.ApiComunicadosGetPath + '/getMainLabs').pipe(
            catchError(err => {
            console.error('Error fetching main RGPD labs', err);
            return [];
            })
        );
    }

    // GET others labs
    getOthersRgpdLabs(): Observable<RGPDLabs[]> {
        return this.http.get<RGPDLabs[]>(this.ApiComunicadosGetPath + '/getOthersLabs').pipe(
            catchError(err => {
            console.error('Error fetching other RGPD labs', err);
            return [];
            })
        );
    }

    // GET preferences for a specific client
    getPreferencesByUser(clientId: string): Observable<RGPDLabs[]> {
        return this.http.get<RGPDLabs[]>(this.ApiComunicadosGetPath + `/getPreferencesByUser?clientId=${clientId}`).pipe(
            catchError(err => {
            console.error(`Error fetching RGPD preferences for ${clientId}`, err);
            return [];
            })
        );
    }

    // POST updated preferences
    setPreferences(preferences: RGPDPreferences): Observable<void> {
        return this.http.post<void>(this.ApiComunicadosGetPath + '/setPreferences', preferences).pipe(
            catchError(err => {
            console.error('Error setting RGPD preferences', err);
            throw err;
            })
        );
    }

    // GET all labs
    isFirstRGPD(clientId: string): Observable<boolean> {
        return this.http.get<boolean>(this.ApiComunicadosGetPath + `/isFirstRGPD?clientId=${clientId}`).pipe(
            catchError(err => {
            console.error('Error fetching RGPD labs', err);
            return [];
            })
        );
    }

    // POST upload clients rgpd preferences file
    uploadClientsRGPDFile(file: File): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<any>(this.ApiComunicadosGetPath + '/uploadFile', formData).pipe(
            catchError(err => {
            console.error('Error uploading RGPD file', err);
            throw err; 
            })
        );
    }

    // GET all preferences
    getAllPreferences(page: number, pageSize: number, searchTerm?: string): Observable<PagedResponse<RGPDPreferences>> {
    let url = `${this.ApiComunicadosGetPath}/getAllPreferences?page=${page}&pageSize=${pageSize}`;

    if (searchTerm && searchTerm.trim() !== '') {
        url += `&search=${encodeURIComponent(searchTerm.trim())}`;
    }

    return this.http.get<PagedResponse<RGPDPreferences>>(url).pipe(
        catchError(err => {
        console.error(`Error fetching paged RGPD preferences`, err);
        throw err;
        })
    );
    }

    // Export all preferences as CSV
    exportAllPreferences() {
        return this.http.get(`${this.ApiComunicadosGetPath}/exportAllPreferences`, {
            responseType: 'blob'
        });
    }

}
